import { useContext } from "react"

import Spacer from "@p-ban/common/src/components/layout/Spacer"
import useMountEffect from "@p-ban/common/src/hooks/useMountEffect"
import { isBrowser } from "@p-ban/common/src/utils/CommonUtils"

import LinkLikeButton from "../../../components/mypage/Button/LinkLikeButton"
import AlignCenterHorizontally from "../../../components/mypage/layout/AlignCenterHorizontally"
import Text from "../../../components/ui/Text/Text"
import { resolveSafeReturnUrl } from "../../../logic/auth/returnUrl"
import SignUpTemplate from "../components/SignUpTemplate"
import { SignUpFormContext } from "../context/SignUpFormContext"

const useSignUpComplete = () => {
  const { wasSignedUp } = useContext(SignUpFormContext)

  const url = isBrowser ? resolveSafeReturnUrl() : null

  useMountEffect(() => {
    if (url === null) return

    setTimeout(() => window.location.assign(url), 3000)
  })

  return {
    wasSignedUp,
    willRedirect: url !== null,
  }
}

// TODO : 当画面は使用されていない筈。関連ロジック含めて要削除。
const SignUpComplete = () => {
  const { willRedirect } = useSignUpComplete()

  return (
    <SignUpTemplate currentStep="登録完了" subTitle="登録完了">
      <Text>
        お客様の情報を登録いたしました。
        {willRedirect && (
          <>
            <Spacer size={20} />
            自動でページが切り替わります。しばらくお待ちください。
          </>
        )}
      </Text>
      {!willRedirect && (
        <AlignCenterHorizontally>
          <Spacer size={40} />
          <LinkLikeButton href="/kiban/com/csComTop.do">マイページTopへ</LinkLikeButton>
        </AlignCenterHorizontally>
      )}
    </SignUpTemplate>
  )
}

export default SignUpComplete
